module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/dashboard/dashboard.component.css
// module id = ./src/app/technical/dashboard/dashboard.component.css
// module chunks = main